export default class extends HTMLElement {
  connectedCallback () {
    this.addEventListener('click', this.onClick)
  }

  disconnectedCallback () {
    this.removeEventListener('click', this.onClick)
  }

  onClick = () => {
    const element = document.getElementById(this.dataset.elementId)

    if (!element) return

    const top = element.getBoundingClientRect().top + window.scrollY - Number(this.dataset.offset || 0)

    window.scrollTo({ top, behavior: 'smooth' })
  }
}
